import PropTypes from 'prop-types'
import { cn } from '../../../lib/utils'

// Accent borders are unified to Steel blue (#2C3D4D) across every KPI variant
// per the brand refresh. The `accent` prop is kept so existing callers don't
// have to change, but it no longer changes the visual.
export const KpiCard = ({ label, value, icon: Icon }) => {
  return (
    <div
      className={cn(
        // Mobile: square card, big number on top, centered label below, no accent
        // border. Desktop: original side-by-side row with left accent border.
        'flex flex-1 flex-col items-center justify-center rounded-xl border border-[#D1D5D8] bg-white text-center py-5 px-3',
        'min-[435px]:flex-row min-[435px]:items-center min-[435px]:justify-between min-[435px]:text-left min-[435px]:h-20 min-[435px]:py-0 min-[435px]:px-5 min-[435px]:border-l-[3px] min-[435px]:border-l-[#2C3D4D]'
      )}
    >
      {/* Mobile: number first, label centered below. Desktop: icon + label on
          the left, value right-aligned. */}
      <div className='order-2 mt-2 flex items-center justify-center gap-2.5 min-[435px]:order-1 min-[435px]:mt-0 min-[435px]:justify-start'>
        {Icon && <Icon className='hidden h-5 w-5 text-[#0A1628] min-[435px]:inline-block' strokeWidth={1.75} />}
        <span className='block text-center text-xs font-semibold uppercase tracking-wide text-[#6B7280] min-[435px]:text-left'>
          {label}
        </span>
      </div>
      <span className='order-1 text-[28px] font-bold leading-none text-[#0A1628] min-[435px]:order-2 min-[435px]:font-light min-[435px]:text-[36px]'>
        {value}
      </span>
    </div>
  )
}

KpiCard.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  icon: PropTypes.elementType,
  accent: PropTypes.oneOf(['blue', 'green', 'navy'])
}
